module.exports = __webpack_public_path__ + "img/logo.f4aa1f4a.png";